import getColor from "@insite/mobius/utilities/getColor";
import widgetModule, { salesGoalStyles } from "@stoneage/App/Widgets/SalesGoal/SalesGoal";
import { css } from "styled-components";

salesGoalStyles.barPlaceholder = {
    css: css`
        ${salesGoalStyles.barPlaceholder?.css};
        background-color: ${getColor("common.ui5")};
    `,
};
salesGoalStyles.barDrawer = {
    css: css`
        ${salesGoalStyles.barDrawer?.css};
        background-color: ${getColor("primary")};
    `,
};

export * from "@stoneage/App/Widgets/SalesGoal/SalesGoal";
export default widgetModule;
